export default __webpack_public_path__ + "static/media/calendar.753b575f.svg";